import React from 'react';
import './Book.css';


export default class Book extends React.Component {
    constructor(props) {
        super(props);
        window.scrollTo(0, 0);
        this.handlerNavigatorToBookDetails.bind(this);
    }

    async handlerNavigatorToBookDetails(data) {
        // this.props.history.push(`Livro/${(data.slug)}`, { data: data, componentId:'BookDetails'});
        this.props.history.push(`Livro/${(data.slug)}`, { componentId:'BookDetails'});
    }

    async buttonNavigator(data) {
        this.props.history.push(`Livro/${(data.slug)}`, { componentId:'BookDetails'});
    }


    render() {

        const { data, title, author, history } = this.props;
        const heightBookInfo = title == null ? 60 : 150;

        return (
            <div className="book-container" onClick={() => this.handlerNavigatorToBookDetails(data)}>
                <div className="book station">
                    <img className="book-cover" src={data.image} alt="" />

                    <div style={{ height: `${heightBookInfo}px` }} className="book-info">

                        <div className="book-price">
                            <span>R$</span>
                            <span>  {data.price}</span>
                        </div>

                        {heightBookInfo === 60 ? '' :

                            <div className="book-data">
                                {title.length <= 50 ?
                                    <span>{title}</span>
                                    :
                                    <span>{`${title.substr(0, 40)}...`}</span>

                                }

                                <span>{author}</span>
                            </div>

                        }
                    </div>

                    <div className="container_button_pay">
                      <button className="book-buy-button" onClick={() => null} >
                          <span>DETALHES </span>
                      </button>
                    </div>
                    </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/Book/Book.js